import { gql } from '@apollo/client';

export const DASHBOARD_ECD_REGISTRATION_EFFICIENCY = gql`
  query DashboardEcdRegistrationEfficiency($input: DashboardFilterArgs) {
    totalEcdRegistrationEfficiency(input: $input) {
      packCollection {
        target
        actual
      }
      applicationSubmission {
        target
        actual
      }
      dsdAssessment {
        target
        actual
      }
      ehpAssessment {
        target
        actual
      }
      ehpReport {
        target
        actual
      }
      fileCompilationSubmitted {
        target
        actual
      }
      certificateReceived {
        target
        actual
      }
    }
  }
`;
